import $ from 'jquery';

window.debounce =  function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

const stickyHeader = function() {
  const $header = $('[data-site-header]');
  let topBarHeight, headerHeight;
  const update = () => {
    topBarHeight = $('[data-top-bar]').outerHeight();
    headerHeight = ($header.hasClass('m-transparent') && $(window).width() > 989) ? topBarHeight : $header.outerHeight();
    $('body').css('paddingTop', headerHeight+'px');
    if($("body").hasClass('header-with-sticky-bar')) {
      if($(window).width() > 980) {
        headerHeight += 46;
        topBarHeight += 46;
      }
    }
  }
  
  update();
  $(window).resize(update);
  $(document).scroll(function () {
    const scroll = $(this).scrollTop();
    if (scroll > headerHeight/3) {
      $header.css('transform', `translate(0, -${topBarHeight}px)`).addClass('is-scrolled');
    } else {
      $header.css('transform', `translate(0, 0)`).removeClass('is-scrolled');
    }

    var $btnATC = $(".product-main form#addToCartForm button[data-add-to-cart]");

    if($btnATC.length > 0) {
      if(scroll > $btnATC.offset().top) {
        $('.sticky-bottom').addClass('visible');
      }
      else {
        $('.sticky-bottom').removeClass('visible');
      }
    }
  })
}

const mobileHeader = function() {
  const $btn = $('[data-open-menu]');
  $btn.click(function(e) {
    e.preventDefault();
    $('html, body').toggleClass('is-menu-open');
  })
}

const header = () => {
  stickyHeader();
  mobileHeader();
}

export default header